import { ThemeProvider } from '@offline-mui/material/styles'
import { AdapterDayjs } from '@offline-mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@offline-mui/x-date-pickers/LocalizationProvider'
import type { ReactNode } from 'react'
import theme from './theme'
import './offlineFlight.css'

export function OfflineFlightProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="offline-flight-root">{children}</div>
      </LocalizationProvider>
    </ThemeProvider>
  )
}
